import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AngularSharedComponentsModule, FormBuilderValidationModule } from '@monsido/angular-shared-components';
import { ColorPickerModule } from '@iplab/ngx-color-picker';

import { NgClickOutsideDelayOutsideDirective, NgClickOutsideDirective } from 'ng-click-outside2';
import { PaOptionsService } from './features/pa-script-settings/pa-options.service';
import { PAScriptSettingsComponent } from './features/pa-script-settings/pa-script-settings.component';
import { SampleImageComponent } from './components/sample-image/sample-image.component';
import { ConsentManagerComponent } from './features/consent-manager/consent-manager.component';
import { ConsentManagerOptionsService } from './features/consent-manager/consent-manager-options.service';
import { TranslateModule } from '@client/app/modules/translate.module';
import { ComponentsModule } from '@client/app/components/components.module';
import { FormDomainScriptGuideLegacyComponent } from './legacy/legacy.component';
import { FormDomainScriptGuideLegacyPageAssistComponent } from './legacy/page-assist/page-assist.component';
import { FormDomainScriptGuideLegacyPageAssistSettingsComponent } from './legacy/page-assist/settings/settings.component';
import { FormDomainScriptGuideLegacyStatisticsComponent } from './legacy/statistics/statistics.component';
import { FormDomainScriptGuideFeaturesHeatmapsComponent } from './features/heatmaps/heatmaps.component';
import { FormDomainScriptGuideFeaturesPageAssistComponent } from './features/page-assist/page-assist.component';
import { FormDomainScriptGuideFeaturesPageFixComponent } from './features/page-fix/page-fix.component';
import { FormDomainScriptGuideFeaturesStatisticsComponent } from './features/statistics/statistics.component';
import { FormDomainScriptGuideComponent } from './domain-script-guide.component';
import {
    FormDomainScriptGuideFeaturesCookieBannerComponent,
} from '@client/app/modules/cookie-banner/forms/domain-script-guide/domain-script-guide.component';
import { NgbTooltipMfeModule } from '@client/mfe/overlay/ngb-tooltip-mfe.module';

@NgModule({
    imports: [
        CommonModule,
        NgbTooltipMfeModule,
        AngularSharedComponentsModule,
        ColorPickerModule,
        FormsModule,
        NgClickOutsideDirective,
        NgClickOutsideDelayOutsideDirective,
        FormBuilderValidationModule,
        TranslateModule,
        ComponentsModule,
    ],
    exports: [],
    declarations: [
        FormDomainScriptGuideLegacyComponent,
        FormDomainScriptGuideLegacyPageAssistComponent,
        FormDomainScriptGuideLegacyPageAssistSettingsComponent,
        FormDomainScriptGuideLegacyStatisticsComponent,
        FormDomainScriptGuideFeaturesHeatmapsComponent,
        FormDomainScriptGuideFeaturesPageAssistComponent,
        FormDomainScriptGuideFeaturesPageFixComponent,
        FormDomainScriptGuideFeaturesStatisticsComponent,
        FormDomainScriptGuideComponent,
        PAScriptSettingsComponent,
        SampleImageComponent,
        ConsentManagerComponent,
        FormDomainScriptGuideFeaturesCookieBannerComponent,
    ],
    providers: [
        PaOptionsService,
        ConsentManagerOptionsService,
    ],
})
export class DomainScriptModule {}
